import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import type { YesNo } from "@/lib/documentEditor"

/**
 * document-editor.md's page-local `YesNoRadio` helper, built on the shared
 * `RadioGroup` — models three states (`true`/`false`/`null`), mapping
 * `null` to an empty `value` so both options start unselected.
 */
export function YesNoRadio({
  id,
  value,
  onChange,
}: {
  id: string
  value: YesNo
  onChange: (value: boolean) => void
}) {
  return (
    <RadioGroup
      className="flex gap-4"
      onValueChange={(next) => onChange(next === "yes")}
      value={value === null ? "" : value ? "yes" : "no"}
    >
      <label className="flex items-center gap-2 text-sm" htmlFor={`${id}-yes`}>
        <RadioGroupItem id={`${id}-yes`} value="yes" />
        Так
      </label>
      <label className="flex items-center gap-2 text-sm" htmlFor={`${id}-no`}>
        <RadioGroupItem id={`${id}-no`} value="no" />
        Ні
      </label>
    </RadioGroup>
  )
}
